<script setup>
const props = defineProps({
  text: Object,
  text2: Object,

});
</script>

<template>
  <section class="l-container p-section">
    <div
      class="l-row">
        <div
          v-if="text?.content"
          class="p-col w-full md:w-1/2 mb-xl md:mb-0">
          <div
            v-html="text?.content"
            class="prose"></div>
        </div>
        <div
          v-if="text2?.content"
          class="p-col w-full md:w-1/2">
          <div
            v-html="text2?.content"
            class="prose"></div>
        </div>
    </div>
  </section>
</template>

<style></style>
